import { useEffect } from 'react';
import { useState } from 'react';

const Ourpolicy = () => {
  const [pdfUrl, setPdfUrl] = useState('/assets/images/Policies.pdf');
  const [key, setKey] = useState(0);
  useEffect(() => {
    localStorage.setItem('isHome', true);
  }, []);

  const reloadPdf = () => {
    setPdfUrl('/assets/images/Policy.pdf');
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      {/* <div className="flex-grow md:py-28"> */}
      <object data={pdfUrl} type="application/pdf" width="100%" height="100%" style={{ minHeight: '100vh', marginTop:"90px" }} key={key}>
        <p>
          It appears you don't have a PDF plugin for this browser. You can{' '}
          <a className="text-center text-customgreen mt-5" href={pdfUrl} target="_blank" rel="noopener noreferrer">
            click here to download the PDF file.
          </a>
        </p>
      </object>
      {/* </div>
      <button onClick={reloadPdf}>Reload PDF</button> */}
    </>
  );
};

export default Ourpolicy;
